import { render, staticRenderFns } from "./cancel-appointments.vue?vue&type=template&id=5c02f30b&"
import script from "./cancel-appointments.vue?vue&type=script&lang=js&"
export * from "./cancel-appointments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports